import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface EmotioPsychoRationalAssessmentResult {
  id: string;
  assessmentType: string;
  selectedCategory: number;
  scores: {
    overall: number;
    category1: number;
    category2: number;
    category3: number;
    category4: number;
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const EmotioPsychoRationalAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as EmotioPsychoRationalAssessmentResult;

  if (!assessmentResult) {
    // If no result data, redirect to insights
    navigate('/panel/learn/');
    return null;
  }

  if (!assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/');
    return null;
  }

  try {
    // Determine the display name based on selected category
    const getAssessmentDisplayName = (selectedCategory: number) => {
      switch (selectedCategory) {
        case 1: return 'DASS-21 Assessment';
        case 2: return 'PHQ-9 Assessment';
        case 3: return 'GAD-7 Assessment';
        case 4: return 'Gender Sensitivity Assessment';
        default: return 'EMOTIO-PSYCHO-RATIONAL ASSESSMENT';
      }
    };

    const config = createAssessmentConfig(assessmentResult, {
      assessmentType: 'emotio-psycho-rational',
      assessmentName: 'emotio-psycho-rational-assessment',
      assessmentDisplayName: getAssessmentDisplayName(assessmentResult.selectedCategory),
      redoRoute: '/panel/learn/emotio-psycho-rational-assessment',
      completeRoute: '/panel/insights',
      scoreLabel: 'Integration Score',
      maxScore: 20,
      subtitleMapping: {
        High: 'Low Stress / Good / Green',
        Moderate: 'Moderate Stress / Orange',
        Low: 'High Stress / Bad / Red'
      },
      visualMessage: "You've completed the assessment!",
      resultsTitle: "Here's your integration analysis",
      selectedCategory: assessmentResult.selectedCategory
    });
    
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/');
    return null;
  }
};

export default EmotioPsychoRationalAssessmentCompletionPage;


